const siteMetdata = {
  lang: 'pl-PL',
  domain: 'https://ofin.pl',
  siteUrl: 'https://ofin.pl',
  author: 'ofin',
  title: 'ofin.pl',
  description: '',
};

module.exports = siteMetdata;